const About = () =>
  import(/* webpackChunkName: "umum" */ "../views/statics/About.vue");
const Privacy = () =>
  import(/* webpackChunkName: "umum" */ "../views/statics/Privacy.vue");
const Tos = () =>
  import(/* webpackChunkName: "umum" */ "../views/statics/Tos.vue");
const Contact = () =>
  import(/* webpackChunkName: "umum" */ "../views/statics/Contact.vue");
const Condition = () =>
  import(/* webpackChunkName: "umum" */ "../views/statics/Condition.vue");
const Complaint = () =>
  import(/* webpackChunkName: "umum" */ "../views/statics/Complain.vue");

export default [
  {
    path: "about",
    name: "about",
    component: About,
  },
  {
    path: "privacy",
    name: "privacy",
    component: Privacy,
  },
  {
    path: "tos",
    name: "tos",
    component: Tos,
  },
  {
    path: "contact",
    name: "contact",
    component: Contact,
  },
  {
    path: "condition",
    name: "condition",
    component: Condition,
  },
  {
    path: "complaint",
    name: "complaint",
    component: Complaint,
  },
];
